import _ from "lodash";
import React from "react";
import {
  StarFilled,
  StarOutlined,
  TickLargeOutlined,
} from "@toddle-edu/ds-icons";
import { colors } from "@toddle-edu/ds-theme";
import { Tooltip } from "@toddle-edu/ds-web";
import classNames from "classnames";
import classes from "ProgressReportSetup/routes/VoiceAndOutputStructure/components/VoiceStructure/VoiceStructure.scss";

const styles = {
  starIcon: {
    color: colors.decorativeSurfaceThree,
    flexShrink: "0",
  },
};

export const USER_TYPES = {
  custom: "CUSTOM",
  global: "GLOBAL",
};

export const MENU_OPTIONS_KEYS = {
  edit: "EDIT_COMMENT",
  delete: "DELETE_COMMENT",
  setAsDefault: "SET_AS_DEFAULT",
};

export const sideBarOptions = ({
  voiceTones,
  t,
  onClickStarOutlined = null,
  onKeyDownStarOutlined = null,
  isSelectionVisible = false,
  currentVoice,
  selectedTone = {},
}) => {
  const toneOptions = _.map(voiceTones, tone => {
    const isSelectedVoice =
      _.get(selectedTone, "id", "") === _.get(tone, "id", "");
    const isCurrentVoice =
      _.get(currentVoice, "id", "") === _.get(tone, "id", "");
    const isDefaultVoice = _.get(tone, "isDefault", false);
    const titleContainer = classNames({
      [classes.titleContainer]: true,
      ["text-body-2"]: !isCurrentVoice,
      ["text-textSubtle"]: !isCurrentVoice,
      ["text-textDefault"]: isCurrentVoice,
      ["text-label-3"]: isCurrentVoice,
    });
    const starTitleContainer = classNames({
      [classes.selectStarTitleContainer]: isSelectionVisible,
      [classes.starTitleContainer]: !isSelectionVisible,
    });
    const navigationContainer = classNames({
      [classes.starTitleContainer]: true,
      [classes.starTitleTickContainer]: isSelectionVisible,
    });
    const starIconOutlined = classNames({
      [classes.starIconOutlined]: true,
    });
    const { id, title } = tone;
    const modifiedTitle = (
      <span className={navigationContainer}>
        <span className={starTitleContainer}>
          <span className={titleContainer}>{title}</span>
          {onClickStarOutlined ? (
            <Tooltip
              tooltip={
                isDefaultVoice
                  ? t("progressReport:default_voice")
                  : t("progressReport:set_as_default_voice")
              }
              placement={"bottom"}
            >
              {isDefaultVoice ? (
                <StarFilled style={styles.starIcon} />
              ) : (
                <StarOutlined
                  variant="subtle"
                  onClick={event => onClickStarOutlined({ event, tone })}
                  tabIndex="0"
                  onKeyDown={event => onKeyDownStarOutlined({ event, tone })}
                  className={starIconOutlined}
                />
              )}
            </Tooltip>
          ) : isDefaultVoice ? (
            <Tooltip
              tooltip={t("progressReport:default_voice")}
              placement={"bottom"}
            >
              <StarFilled style={styles.starIcon} />
            </Tooltip>
          ) : null}
        </span>
        {isSelectionVisible && isSelectedVoice && (
          <TickLargeOutlined variant="subtle" />
        )}
      </span>
    );

    return {
      key: id,
      title: modifiedTitle,
      tier: 1,
      parent: "root",
      children: [],
    };
  });

  const result = [
    {
      key: "root",
      children: _.map(toneOptions, "key"),
    },
    ...toneOptions,
  ];

  return result;
};
